export const relationsState = state => state.relations;

export const getLoadingRelations = state => relationsState(state).loading;

export const getRelations = state => relationsState(state).relations;

export const getResponseRelations = state => relationsState(state).response;

export const getTabSelected = state => relationsState(state).tabSelected;
